import { Pipe, PipeTransform } from '@angular/core';

    @Pipe({
        name: 'percentPipe',
        //pure: false
    })

export class PercentPipe implements PipeTransform {

    public transform(value: any) {
      console.log('porcentaje '+ value)
      if (value != null && value != undefined &&  !Number.isNaN(value)){
        value = value.toString()
        value = value.replace("%","");
        return value+"%" ;
      }else{
        return 0;
      }

    }
}
